import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'
import { GroupVisibility } from 'app/types/GroupVisibility'

export const query = gql`
  query fetchGroup($id: String!) {
    Group(id: $id) {
      id
      name
      description
      visibility
      totalMembers
      coverImage {
        id
        width
        height
        url
        sizes {
          cover {
            url
          }
        }
      }
      profileImage {
        id
        width
        height
        url
        sizes {
          medium {
            url
          }
          small {
            url
          }
        }
      }
      university {
        slug
      }
      universityCourse {
        slug
      }
      mainCategory {
        id
        name
      }
      subCategories {
        id
        name
      }
      allowedUserTypes
      meta {
        title
        description
      }
    }
  }
`

export interface GroupQueryInput {
  id: string
}

export interface GroupQueryOutput {
  Group: {
    id: string
    name: string
    description: string
    visibility: GroupVisibility
    totalMembers: number
    coverImage: {
      id: string
      url: string
      width: number
      height: number
      sizes: {
        cover: {
          url: string
        }
      }
    }
    profileImage: {
      id: string
      url: string
      width: number
      height: number
      sizes: {
        small: {
          url: string
        }
        medium: {
          url: string
        }
      }
    }
    university?: {
      slug: string
    }
    universityCourse?: {
      slug: string
    }
    allowedUserTypes: string[]
    mainCategory: {
      id: string
      name: string
    }
    subCategories: {
      id: string
      name: string
    }[]
    meta: {
      title: string
      description: string
    }
  }
}

export const useGroupQuery = (
  options: QueryHookOptions<GroupQueryOutput, GroupQueryInput>
) => usePersistedCacheQuery<GroupQueryOutput, GroupQueryInput>(query, options)

export const groupQuery = {
  query
}
